function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 20,
  height: 20,
  viewBox: "0 0 256 256"
}, props), /*#__PURE__*/React.createElement("g", {
  style: {
    stroke: "none",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "nonzero",
    opacity: 1
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M87.271 58.489H55.952a1.5 1.5 0 0 1 0-3H87.27a1.5 1.5 0 0 1 .001 3",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.42 66.021c-4.98 0-9.033-4.052-9.033-9.032s4.052-9.033 9.033-9.033 9.032 4.053 9.032 9.033-4.052 9.032-9.032 9.032m0-15.065a6.04 6.04 0 0 0-6.033 6.033 6.04 6.04 0 0 0 6.033 6.032 6.04 6.04 0 0 0 6.032-6.032 6.04 6.04 0 0 0-6.032-6.033",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.887 58.489H2.73a1.5 1.5 0 1 1 0-3h38.157a1.5 1.5 0 1 1 0 3M87.271 34.511H27.416a1.5 1.5 0 1 1 0-3H87.27a1.5 1.5 0 0 1 .001 3",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.883 42.043c-4.98 0-9.033-4.052-9.033-9.033s4.052-9.033 9.033-9.033 9.033 4.052 9.033 9.033-4.052 9.033-9.033 9.033m0-15.065c-3.327 0-6.033 2.706-6.033 6.033s2.706 6.033 6.033 6.033 6.033-2.706 6.033-6.033-2.706-6.033-6.033-6.033",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.351 34.511H2.73a1.5 1.5 0 1 1 0-3h9.621a1.5 1.5 0 1 1 0 3M58.088 10.533H2.73a1.5 1.5 0 1 1 0-3h55.358a1.5 1.5 0 1 1 0 3",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.62 18.065c-4.98 0-9.032-4.052-9.032-9.033S60.64 0 65.62 0s9.033 4.052 9.033 9.033-4.052 9.032-9.033 9.032M65.62 3c-3.326 0-6.032 2.706-6.032 6.033s2.706 6.033 6.032 6.033 6.033-2.706 6.033-6.033S68.947 3 65.62 3",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.271 10.533H73.153a1.5 1.5 0 1 1 0-3H87.27a1.5 1.5 0 0 1 .001 3M87.271 82.468H27.416a1.5 1.5 0 1 1 0-3H87.27a1.5 1.5 0 0 1 .001 3",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.883 90c-4.98 0-9.033-4.052-9.033-9.032s4.052-9.033 9.033-9.033 9.033 4.053 9.033 9.033S24.864 90 19.883 90m0-15.065a6.04 6.04 0 0 0-6.033 6.033c0 3.326 2.706 6.032 6.033 6.032s6.033-2.706 6.033-6.032a6.04 6.04 0 0 0-6.033-6.033",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.351 82.468H2.73a1.5 1.5 0 1 1 0-3h9.621a1.5 1.5 0 1 1 0 3",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
})));
export default SvgFilter;